import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Resets scroll to the top on every route change. Combined with
// `history.scrollRestoration = "manual"` (set in index.js), this also prevents
// the browser from restoring a previous scroll position on refresh — which was
// causing the page to land at the bottom after a reload.
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

export default ScrollToTop;
